import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoMarqueeLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/photoMarquee" */ './PhotoMarquee'), 'PhotoMarqueeLayout');
